<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.sign_list' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCancelButton()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<ng-container *ngIf="notifyWarning">
  <div class="mt-3">
      <span>
    <em [innerHTML]="notifyWarning | translate" class="cl-e03"></em>
  </span>
  </div>
</ng-container>
<div class="row pb-2 py-3">
    <div class="col-12">
        <span>{{'search_form.sign_batch' | translate}}</span>
        <span style="color: #fc1203;">{{dataSource.length}}</span>
        <span>{{'search_form.sign_batch_contracts' | translate}}</span>
        <span style="color: #fc1203;">{{noOfFiles}}</span>
        <span>{{'search_form.sign_batch_files' | translate}}</span>
    </div>
</div>
<mat-dialog-content>
    <mat-table [dataSource]="dataSource" class="mt-3">
        <!-- STT -->
        <ng-container matColumnDef="STT">
            <mat-header-cell style="max-width: 5%" *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
            </mat-header-cell>
            <mat-cell style="max-width: 5%" *matCellDef="let element, let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
                {{i + 1}}
            </mat-cell>
        </ng-container>

        <!-- Tên tài liệu Column -->
        <ng-container matColumnDef="contractName">
            <mat-header-cell *matHeaderCellDef style="max-width: 50%" class="mat-cell-non-boder-right-bottom with-colum1">
                {{'headertable.document_code_name' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="max-width: 50%" matTooltip="{{ element.contractName }}" class="mat-cell-non-boder-right-bottom with-colum1"
                (click)="$event.stopPropagation()">
                <span class="fix-width">{{element.contractName}}</span>
            </mat-cell>
        </ng-container>

        <!-- Số file Column -->
        <ng-container matColumnDef="noOfFile">
            <mat-header-cell *matHeaderCellDef style="max-width: 15%" class="mat-cell-non-boder-right-bottom with-colum2">
                {{'headertable.no_of_files' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="max-width: 15%" class="mat-cell-non-boder-right-bottom number-cell-center with-colum2"
                (click)="$event.stopPropagation()">
                <span class="fix-width">{{element.contractAttachments ? element.contractAttachments.length : '0'}}</span>
            </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="memoryStorage">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'search_form.memory_storage' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom"
                        matTooltip="{{ element.capacity / 1024 / 1024 | number:'.0-3' }}MB"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.capacity / 1024 / 1024 | number:'.0-3'}}MB</span>
              </mat-cell>
            </ng-container> -->

        <!-- Tên các bên ký kết Column -->
        <!-- <ng-container matColumnDef="serviceTypeName">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                {{'search_form.type_of_doc' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" matTooltip="{{ element.contractType }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.contractType}}</span>
            </mat-cell>
        </ng-container> -->

        

        <!-- Người chuyển Column -->
        <!-- <ng-container matColumnDef="effectiveDate">
            <mat-header-cell *matHeaderCellDef style="max-width: 12%;" class="mat-cell-non-boder-right-bottom">
                {{'headertable.document_date' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="max-width: 12%;" matTooltip="{{ element.effectiveDate }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{ element.effectiveDate}}</span>
            </mat-cell>
        </ng-container> -->


        <!-- Ngày nhận -->
        <ng-container matColumnDef="expireDate">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom" style="max-width: 30%;">{{'headertable.document_date' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" matTooltip="{{ element.effectiveDate  }}"
                class="mat-cell-non-border-right-bottom number-cell-center" (click)="$event.stopPropagation()"
                style="max-width: 30%;">
                <span class="fix-width">{{ element.effectiveDate}}</span>
            </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="createdBy">
            <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom"
                            style="max-width: 10%;">
            {{'cloud_ca_management.add_new.create_by' | translate}}
            </mat-header-cell>
            <mat-cell (click)="$event.stopPropagation()"
                    *matCellDef="let element" class="mat-cell-non-border-right-bottom number-cell-center"
                    style="max-width: 10%;">
            <span>{{element.createdBy}}</span>
            </mat-cell>
        </ng-container> -->

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
        </mat-row>
    </mat-table>
    <div *ngIf="dataSource.length == 0" class="w-100 text-center" style="padding-top: 16px;color: #5a5c69;font-size: 14px;">{{'form.no_record' | translate}}</div>
    <!-- Pagination -->
</mat-dialog-content>
<mat-divider class="mt-3"></mat-divider>
<mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button cdkFocusInitial [disabled]="dataSource.length == 0" (click)="onClickConfirmButton()" color="primary" >
        <mat-icon class="mr-0">done_all</mat-icon>
        {{'button.confirm' | translate}}
    </button>
</mat-dialog-actions>
